import { render, staticRenderFns } from "./ZztShenchaModal.vue?vue&type=template&id=71bfa80a&"
import script from "./ZztShenchaModal.vue?vue&type=script&lang=js&"
export * from "./ZztShenchaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports